import { useFormik } from 'formik';
import React, { useState } from 'react'
import { AiOutlineMail, AiOutlinePhone } from 'react-icons/ai'
import { RiLockPasswordLine } from 'react-icons/ri'
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import LoginButton from '../../buttons/LoginButton';
import { Form } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import { LoginRes, LoginTodo } from '../../../redux/slices/LoginSlice/Login'
import { logInSchema } from './Validation';
import { FaUserCheck } from "react-icons/fa";

export default function LoginForm() {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const [spiner, setSpiner] = useState(false)
    const location = useLocation()

    const initiaValues = {
        phone: '',
        password: '',
    }

    const { values, errors, touched, handleBlur, handleChange, handleSubmit } = useFormik({
        initialValues: initiaValues,
        validationSchema: logInSchema,

        onSubmit: (values, action) => {
            setSpiner(true)
            dispatch(LoginTodo(values)).then(() => loginRes())

        }
    })


    const loginRes = () => {
        if (LoginRes?.status) {
            localStorage.setItem('userId', LoginRes?.data[0]?.userId)
            localStorage.setItem('name', LoginRes?.data[0]?.Name)
            localStorage.setItem('emailId', LoginRes?.data[0]?.Email)
            localStorage.setItem('userRole', LoginRes?.data[0]?.userRole)
            localStorage.setItem('token', LoginRes?.data[0]?.Token)

            toast.success(LoginRes?.message, { position: "bottom-right" });
            setTimeout(() => {
                setSpiner(false);
                navigate('/dashboard')
            }, 1000);
        } else {
            setSpiner(false);
            toast.error(LoginRes?.message, { position: "bottom-right" });
        }
    }

    return (
        <>
            <div className='mt-4'>
                <Form onSubmit={handleSubmit}>
                    <div>
                        <label className='login_label'>Phone Number</label>
                        <div className="input-group input_section" style={{ position: 'relative' }}>
                            <span className='input_icon'> <AiOutlinePhone className='mb-1 me-2' style={{ color: "white" }} size={22} /></span>
                            <input type="tel" className="form-control form-login-input login_placeholder " placeholder='Enter Phone Number'
                                name='phone'
                                value={values.phone}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                        </div>
                        {errors.phone && touched.phone ? (<span className='text-danger mt-2' style={{ display: 'flex', justifyContent: 'flex-start', fontSize: '14px' }} >{errors.phone}</span>) : null}
                    </div>
                    <div className='mt-4'>
                        <label className='login_label'>Password</label>
                        <div className="input-group input_section" style={{ position: 'relative' }}>
                            <span className='input_icon'> <RiLockPasswordLine style={{ color: "white" }} className='mb-1 me-2' size={22} /></span>
                            <input type="password" className="form-control form-login-input " placeholder='Enter password'
                                name='password'
                                value={values.password}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                        </div>
                        {errors.password && touched.password ? (<span className='text-danger mt-1' style={{ display: 'flex', justifyContent: 'flex-start', fontSize: '14px' }} >{errors.password}</span>) : null}
                    </div>
                    <div className='mt-4 d-flex justify-content-center'>
                        <LoginButton name={'Sign In'} spiner={spiner} />
                    </div>
                </Form>
            </div>

        </>
    )
}
